<template>
  <b-row class="pb-4 pt-3">
    <b-col cols="12" offset-sm="1" sm="3">
      <label>{{ label }}</label>
    </b-col>
    <b-col cols="12" sm="7">
      <div class="mb-2">
        <b-form-checkbox
          :name="handle + '_activate'"
          size="lg"
          v-model="activate"
          @input="updateField($event)"
        >
        {{ activateLabel }}
      </b-form-checkbox>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
        <b-form-text v-html="activateDesc"></b-form-text>
      </div>
      <div v-if="activate">
        <div class="mb-2">
          <b-form-select
            v-if="openInModal"
            :name="handle + '_internalPage'"
            v-model="internalPageSlug"
            :options="internalPageOptions"
            @change="handleInternalPageChange"
          />
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
          <b-form-text v-if="openInModal" v-html="internalPageDesc"></b-form-text>
        </div>
        <div class="mb-2">
          <b-form-input
            :name="handle + '_url'"
            v-model="url"
            :placeholder="urlPlaceholder"
            debounce="500"
            @update="updateField"
          ></b-form-input>
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
          <b-form-text v-html="urlDesc"></b-form-text>
        </div>
        <div class="mb-2">
          <b-form-input
            :name="handle + '_text'"
            v-model="text"
            :placeholder="textPlaceholder"
            debounce="500"
            @update="updateField"
          ></b-form-input>
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
          <b-form-text v-if="desc" v-html="desc"></b-form-text>
        </div>
        <div class="mb-2">
          <b-form-checkbox
            :name="handle + '_showOnMobile'"
            size="lg"
            v-model="showOnMobile"
            @input="updateField"
          >
          {{ showOnMobileLabel }}
        </b-form-checkbox>
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
          <b-form-text v-html="showOnMobileDesc"></b-form-text>
        </div>
        <div class="mb-2">
          <b-form-checkbox
            :name="handle + '_openInModal'"
            size="lg"
            v-model="openInModal"
            @input="updateField"
          >
          {{ openInModalLabel }}
        </b-form-checkbox>
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
          <b-form-text v-html="openInModalDesc"></b-form-text>
        </div>
        <div v-if="openInModal">
          <div class="mb-2">
            <b-form-select
              :name="handle + '_modalSize'"
              v-model="modalSize"
              :options="modalSizeOptions"
              @input="updateField"
            />
            <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
            <b-form-text v-html="modalSizeDesc"></b-form-text>
          </div>
          <div class="mb-2">
            <b-form-checkbox
              :name="handle + '_modalCentered'"
              size="lg"
              v-model="modalCentered"
              @input="updateField"
            >
            {{ modalCenteredLabel }}
          </b-form-checkbox>
            <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
            <b-form-text v-html="modalCenteredDesc"></b-form-text>
          </div>
        </div>
        <div class="mb-2" v-if="!openInModal">
          <b-form-checkbox
            :name="handle + '_openInNewTab'"
            size="lg"
            v-model="openInNewTab"
            @input="updateField($event)"
          >
          {{ openInNewTabLabel }}
        </b-form-checkbox>
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
          <b-form-text v-html="openInNewTabDesc"></b-form-text>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import GetAllPagesOfProjectById from '@/graphQlQueries/queries/getAllPagesOfProjectBySlugPath';

export default {
  name: 'CustomButtonRow',
  props: {
    valueFromDb: { type: Object, default: null },
    handle: { type: String, default: null },
    label: { type: String, default: null },
    desc: { type: String, default: null },
    projectId: { type: Number, default: null },
  },
  computed: {
    internalPageOptions() {
      if (this.pages.length === 0) {
        return [
          { value: null, text: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.internalPageEmpty') },
        ];
      }
      return [
        { value: null, text: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.internalPageSelect') },
        ...this.pages.map((page) => ({ value: page.slug, text: page.name })),
      ];
    },
  },
  data() {
    return {
      activate: false,
      activateLabel: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.activate'),
      activateDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.activateDesc'),
      url: null,
      urlPlaceholder: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.url'),
      urlDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.urlDesc'),
      internalPageSlug: null,
      internalPageDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.internalPageDesc'),
      pages: [],
      text: null,
      textDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.textDesc'),
      textPlaceholder: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.textPlaceholder'),
      showOnMobile: false,
      showOnMobileLabel: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.showOnMobile'),
      showOnMobileDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.showOnMobileDesc'),
      openInModal: false,
      openInModalLabel: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.openInModal'),
      openInModalDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.openInModalDesc'),
      modalSize: null,
      modalSizeLabel: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.modalSize'),
      modalSizeDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.modalSizeDesc'),
      modalSizeOptions: [
        { value: null, text: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.modalSizeDefault') },
        { value: 'sm', text: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.modalSizeSm') },
        { value: 'xl', text: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.modalSizeXl') },
        { value: 'full', text: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.modalSizeFull') },
      ],
      modalCentered: false,
      modalCenteredLabel: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.modalCentered'),
      modalCenteredDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.modalCenteredDesc'),
      openInNewTab: false,
      openInNewTabLabel: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.openInNewTab'),
      openInNewTabDesc: this.$t('settings.project.projectType.themeSetting.navigation.custom_button.openInNewTabDesc'),
    };
  },
  apollo: {
    pages: {
      query: GetAllPagesOfProjectById,
      variables() {
        return {
          projectId: this.projectId,
        };
      },
      update(data) {
        return data?.projects_by_pk?.child_pages || [];
      },
      fetchPolicy: 'network-only',
      skip() {
        return !this.projectId;
      },
    },
  },
  created() {
    if (this.valueFromDb) {
      this.activate = !!this.valueFromDb.activate;
      this.url = this.valueFromDb.url;
      this.text = this.valueFromDb.text;
      this.showOnMobile = this.valueFromDb.showOnMobile;
      this.openInModal = !!this.valueFromDb.openInModal;
      this.modalSize = this.valueFromDb.modalSize ?? null;
      this.modalCentered = !!this.valueFromDb.modalCentered;
      this.openInNewTab = !this.openInModal && !!this.valueFromDb.openInNewTab;
      this.internalPageSlug = this.url || null;
    }
  },
  methods: {
    handleInternalPageChange(value) {
      this.url = value;
      this.updateField();
    },
    updateField() {
      const shouldOpenInNewTab = !this.openInModal && this.openInNewTab;
      const button = {
        activate: this.activate,
        url: this.url,
        text: this.text,
        showOnMobile: this.showOnMobile,
        openInModal: this.openInModal,
        modalSize: this.modalSize,
        modalCentered: this.modalCentered,
        openInNewTab: shouldOpenInNewTab,
      };
      this.$emit('update-field', button);
    },
  },
};
</script>
